<template>
    <!-- <v-container class="fill-height fluid" @keyup.enter="login"> -->
    <v-container class="mycontainer" @keyup.enter="login">
        <!-- <v-img src="../assets/background-large.png" style="width:100%; height:100%; position:absolute; top:0; left:0;"></v-img> -->
        <!-- <v-row justify="center" no-gutters> -->
        <v-row justify="center">
            <v-col cols="12" sm="8" md="4" align-self="center">
                <new-user @newUser="newUser" okText="registrer" class="ma-5">
                    <template v-slot:returnLink>
                        <v-btn text color="#CCCCCC" small to="/login">
                            <v-icon left>mdi-login</v-icon>
                            Logg inn
                        </v-btn>
                    </template>
                </new-user>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({}),
    methods: {
        newUser() {
            // debugger;
            this.$router.push({ name: "login" });
        }
    }
};
</script>

<style lang="scss" scoped>
.mycontainer {
    display: flex;
    background-color: rgb(227, 229, 229);
    background-image: url("../assets/background-large.png");
    background-position: top left;
    // background-size: 100vw;
    background-size: cover;

    max-width: 6000px;
    max-height: 6000px;
   
    // width: 100vw;
    min-height: 100vh;

    margin: 0;
    padding: 0;
}
</style>